import tbSpinner from './tb-spinner.component'

export default angular
  .module('tb.spinner', [])
  .component('tbSpinner', tbSpinner)
  .name
